export const INITIAL_STATE = {
  selectedTab: "",
  apmStep: "",
  hostStep: "",
};

export const SET_TAB = "onboarding/SET_TAB";
export const SET_APM_STEP = "onboarding/SET_APM_STEP";
export const SET_HOST_STEP = "onboarding/SET_HOST_STEP";

const tabReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_TAB:
      return {
        ...state,
        selectedTab: action.tab,
      };
    case SET_APM_STEP:
      return {
        ...state,

        apmStep: action.apmStep,
      };
    case SET_HOST_STEP:
      return {
        ...state,

        hostStep: action.hostStep,
      };
    default:
      return state;
  }
};

export const setTab = tab => {
  return {
    type: SET_TAB,
    tab,
  };
};

export const setApmStep = apmStep => {
  return {
    type: SET_APM_STEP,
    apmStep,
  };
};

export const setHostStep = hostStep => {
  return {
    type: SET_HOST_STEP,
    hostStep,
  };
};

export default tabReducer;
